module.exports = new __parcel__URL__("open_all_button_disabled.48171e25.png").toString();